import { RoleState } from "global/RoleState";
import { Navigate, useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { ROUTE_PERMISSIONS } from "./routePermissions";

const RoleGuard = ({ children }) => {
  const [role, setRole] = useRecoilState(RoleState);
  const location = useLocation();

  const path = location.pathname;

  const allowedRoles = ROUTE_PERMISSIONS[path];

  // If route is not restricted, allow access
  if (!allowedRoles) {
    return children;
  }

  // If role not allowed → redirect to "/"
  if (!allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RoleGuard;
